import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openNotificationModal } from 'bento-ordering/base/actions/notificationModals';
import { MENU_HOURS_EXPIRED } from 'bento-ordering/cart/constants/notificationTypes';

import { checkIfCurrentMenuIsExpired } from 'bento-ordering/menus/actions';

class LaunchNotificationOnMount extends React.Component {
  static propTypes = {
    handleCallback: PropTypes.func,
    dispatch: PropTypes.func
  };

  static defaultProps = {
    handleCallback: () => {}
  };

  componentDidMount() {
    this.checkIfMenuExpired();
  }

  checkIfMenuExpired() {
    const isExpired = this.props.dispatch(checkIfCurrentMenuIsExpired());
    if (isExpired) {
      this.props.handleCallback();
      this.props.dispatch(openNotificationModal(MENU_HOURS_EXPIRED));
    }
  }

  render() {
    return null;
  }
}

export default connect()(LaunchNotificationOnMount);
